var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{attrs:{"disabled":_vm.disabled,"editor-options":_vm.editorSettings,"editor-toolbar":_vm.customToolbar},on:{"blur":function($event){return _vm.$emit('blur', $event)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }